import React from "react";
import PropTypes from "prop-types";
import { MODAL_SIZE, ModalForm } from "components/Modal";
import { SIZE, TYPE } from "components/Form";
import { GET_INTERVIEWS, GET_MISSION_ROLE_INTERVIEW } from "graphql/queries";
import { ADD_MISSION_ROLE_INTERVIEW_FROM_TEMPLATE } from "graphql/mutations";
import { MUTATION_TYPE, useToast } from "hooks";
import { FormattedMessage } from "react-intl";

/**
 * RoleInterviewTemplateForm
 *
 * @param {Object}    missionRole
 * @param {Boolean}   show
 * @param {Function}  onClose
 */
const RoleInterviewTemplateForm = ({ missionRole, show, onClose, ...props }) => {
  const { toast } = useToast();

  const handleComplete = () => {
    toast.success(<FormattedMessage id="Missions.Roles.RoleInterviewTemplateForm.CreateSuccess" />);
  };

  const handleError = () => {
    toast.error(<FormattedMessage id="Missions.Roles.RoleInterviewTemplateForm.CreateError" />);
  };

  return (
    <ModalForm
      show={show}
      title="Role Interview Template"
      size={MODAL_SIZE.small}
      onClose={onClose}
      onCompleted={handleComplete}
      onError={handleError}
      data={FORM_DATA}
      parentKeyName="missionRoleId"
      parentKeyValue={missionRole?.id}
      mutationType={MUTATION_TYPE.add}
      mutationData={{
        mutationName: {
          add: ADD_MISSION_ROLE_INTERVIEW_FROM_TEMPLATE,
        },
        refetchAfterMutate: true,
        refetchQueries: [GET_MISSION_ROLE_INTERVIEW],
      }}
      {...props}
    />
  );
};

const FORM_DATA = [
  {
    items: [
      {
        label: "Template",
        type: TYPE.select,
        size: SIZE.xlarge,
        properties: {
          name: "templateInterviewId",
          required: true,
          queryName: GET_INTERVIEWS,
          queryKeyName: "interviews",
          queryVariables: {
            filters: {
              type: "PLATFORM",
              template: true,
              published: false,
            },
          },
          labelKey: "name",
          valueKey: "id",
        },
      },
    ],
  },
];

RoleInterviewTemplateForm.propTypes = {
  missionRole: PropTypes.object.isRequired,
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default RoleInterviewTemplateForm;
